/* eslint-disable jsx-a11y/no-onchange */
/* eslint-disable jsx-a11y/label-has-associated-control */
import AdvancedSearchForm from 'app/components/partials/category-search/advanced-search-form';
import { ARTWORK_SORT_FILTER } from 'config/search-options';
import classnames from 'classnames';
import Icon from 'app/components/partials/icon';
import PropTypes from 'prop-types';
import { useSearchParams } from 'react-router-dom';
import React, { useEffect, useRef, useState } from 'react';

const ArtworkFilter = ({ formik }) => {
    const [searchParams] = useSearchParams();
    const [openOptionList, setOpenOptionList] = useState(false);
    const filterRef = useRef();

    const sortSelectedOption = ARTWORK_SORT_FILTER.options.find((option) => option.value === searchParams.get('sort')) || null;

    const toggleDropdownHandler = () => {
        setOpenOptionList((prevValue) => !prevValue);
    };

    const filterHandler = (key, value) => {
        formik.setFieldValue(key, value);
        setOpenOptionList(false);
        formik.submitForm();
    };

    const handleClickOutside = (event) => {
        if (filterRef.current && !filterRef.current.contains(event.target)) {
            setOpenOptionList(false);
        } else if (event.target.type === 'submit') {
            setOpenOptionList(false);
        }
    };

    useEffect(() => {
        const optionHeight = filterRef.current.getElementsByClassName('options')[0].clientHeight;
        const marginBottom = openOptionList ? `${optionHeight}px` : null;
        filterRef.current.style['margin-bottom'] = marginBottom;

        if (openOptionList === false) {
            return;
        }
        document.addEventListener('click', handleClickOutside, true);

        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [openOptionList]);

    return (
        <div className="filter-groups" ref={filterRef}>
            <span className="filter-group-label">Sort by</span>
            <div className="search-categories-dropdown">
                <button type="button" className="button || default">
                    <span>{ sortSelectedOption ? sortSelectedOption.label : 'Relevance'}</span>
                    <Icon name="arrow" width="15" height="15" title="" />
                </button>
                <select className="system-select" value={ARTWORK_SORT_FILTER.options[ARTWORK_SORT_FILTER.defaultIndex].value} onChange={(e) => filterHandler('sort', e.target.value)}>
                    {ARTWORK_SORT_FILTER.options.map((item, index) => {
                        return <option key={index} value={item.value}>{item.label}</option>;
                    })}
                </select>
            </div>

            <div className={ classnames('filter-dropdown', openOptionList ? 'open' : '') } >
                <button type="button" className="button || default" onClick={toggleDropdownHandler}>
                    <span>Refine results</span>
                    <Icon name="arrow" width="15" height="15" title="" />
                </button>
            </div>
            <AdvancedSearchForm className={openOptionList ? '' : 'is-hidden'} formik={formik} />
        </div>
    );
};

ArtworkFilter.propTypes = {
    formik: PropTypes.object.isRequired
};

export default ArtworkFilter;
